import { render, staticRenderFns } from "./PayersPageSettingModal.vue?vue&type=template&id=62b40d02&scoped=true"
import script from "./PayersPageSettingModal.vue?vue&type=script&lang=js"
export * from "./PayersPageSettingModal.vue?vue&type=script&lang=js"
import style0 from "./PayersPageSettingModal.vue?vue&type=style&index=0&id=62b40d02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b40d02",
  null
  
)

export default component.exports